
































import { status, risk } from '@/util/transformString/translationsDecorator';
import { tTransactionModal } from '@/store/interfaces/transactions';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Transaction',
  props: {
    transaction: {
      required: true,
      type: Object as PropType<tTransactionModal>,
    },
  },
  data: () => ({
    risk,
    status,
  }),
  computed: {
    isCreditCardOrBot(): boolean {
      return (
        this.transaction.distribution === 'credit_card' ||
        this.transaction.distribution === 'both'
      );
    },
  },
});
